import { create } from 'zustand'
import { devtools, subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { createAccountActionsSlice, createAccountDataSlice } from './slices'
import type { AccountStore } from './types'

export const useAccountStore = create<AccountStore>()(
  devtools(
    subscribeWithSelector(
      immer((...args) => ({
        ...createAccountDataSlice(...args),
        ...createAccountActionsSlice(...args),
      }))
    ),
    {
      name: 'AccountSettingsStore',
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
